import { useNavigate } from "react-router-dom";
import { SearchLink } from "./types.ts";

export default function useSampleTypeahead(searchTerm: string): SearchLink[] {
  const urlParams = new URLSearchParams();
  urlParams.append("q", searchTerm);
  const navigate = useNavigate();

  // For sample search, we only show the direct search option
  // No book-content search and no license-based asset matches
  return [
    {
      type: "titles",
      term: searchTerm,
      action: () => {
        void navigate(`/search/sample/titles?${urlParams.toString()}`);
      },
    },
  ];
}
